import Text from 'components/Text/Text';
import BtnBlock from './components/BtnBlock';
import WordingField from './components/WordingField/WordingField';
import React, { useContext, useEffect } from 'react';
import CategorySelect from './components/CategorySelect';
import KeyField from './components/KeyField';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { AddWordingsContext, IAddWordingsContext } from '../../addWordingsState/addWordingsContext';
import style from './InputFields.module.scss';

const InputFields = () => {
	const {
		setDataForSubmit,
		changeTypeOfModalWindow,
		setIDCategory,
		changeLabels,
		changeValues,
		changeKey,
		IDSelectedCategory,
		key,
		fetchedLanguages,
		translations,
	} = useContext<IAddWordingsContext>(AddWordingsContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ IDSelectedCategory, key });
		translations.map((el) =>
			form.setFieldsValue({ [`label-${el.languageId}`]: el.label, [`value-${el.languageId}`]: el.value }),
		);
	}, [IDSelectedCategory, key, translations]);

	const submit = async () => {
		setDataForSubmit({
			groupId: IDSelectedCategory || '',
			key,
			translations,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<Form
			data-test="InputFields"
			className={style.form}
			form={form}
			name="basic"
			onFinish={submit}
			onKeyPress={preventDefaultForEnterKey}
			layout="vertical">
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="labelsHeading"
					theme="secondary"
					size="l"
					weight="bold"
					display="inline"
				/>
				<CategorySelect setIDCategory={setIDCategory} />
				<KeyField changeKey={changeKey} />
			</div>
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="textHeading"
					theme="secondary"
					size="l"
					weight="bold"
					display="inline"
				/>
				{fetchedLanguages.map((el) => (
					<WordingField
						key={el.id}
						languageData={el}
						changeValues={changeValues}
						changeLabels={changeLabels}
					/>
				))}
			</div>
			<BtnBlock />
		</Form>
	);
};

export default InputFields;
